import { useState } from 'react';
import { Badge, Tooltip, ActionIcon } from '@mantine/core';
import { IconKeyOff } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { useMediaQuery } from '@mantine/hooks';
import { api } from '../lib/api';
import { WeclappTokenTutorial } from './WeclappTokenTutorial';

/**
 * Kopfzeilen-Hinweis, solange kein persönlicher weclapp-Token hinterlegt ist.
 *
 * Ohne Token laufen Kommentare und Zeiten des Technikers über den gemeinsamen
 * Portal-Zugang und erscheinen in weclapp unter fremdem Namen — das merkt sonst
 * niemand, deshalb der dauerhafte Hinweis neben der Online-Anzeige. Klick öffnet
 * die Anleitung und führt zum Eintragen.
 */
export function WeclappTokenIndicator() {
  const [tutorialOpen, setTutorialOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 48em)');

  const { data } = useQuery({
    queryKey: ['auth-me'],
    queryFn: () => api.getMe(),
    staleTime: 300_000,
  });

  // Erst anzeigen, wenn die Antwort da ist — ein Aufblitzen bei jedem Seitenaufruf
  // wäre schlimmer als der Hinweis selbst.
  if (!data?.user || data.user.hasWeclappApiToken !== false) return null;

  const label = 'weclapp-Token fehlt — deine Einträge laufen unter fremdem Namen. Klicken für Anleitung.';

  return (
    <>
      <Tooltip label={label} multiline w={260} withArrow>
        {isMobile ? (
          <ActionIcon
            variant="light"
            color="yellow"
            aria-label={label}
            onClick={() => setTutorialOpen(true)}
          >
            <IconKeyOff size={16} />
          </ActionIcon>
        ) : (
          <Badge
            color="yellow"
            variant="light"
            leftSection={<IconKeyOff size={12} />}
            style={{ cursor: 'pointer' }}
            onClick={() => setTutorialOpen(true)}
          >
            weclapp-Token fehlt
          </Badge>
        )}
      </Tooltip>

      <WeclappTokenTutorial opened={tutorialOpen} onClose={() => setTutorialOpen(false)} />
    </>
  );
}
